export default __webpack_public_path__ + "static/media/laborvetro.e78dee08.png";